import { GetAgencyStatus, EditAgencyStatus,InsertAgencyStatus, DELETEAgencyStatus } from "../type";
import {  InsertData } from "../../Hooks/InsertData";
import { GetDataToken } from "../../Hooks/getAllData";
import { InsUpdateData } from "../../Hooks/UpdataData";
import DeleteData from "../../Hooks/DeleteData";
export const CreateAgencyStatusAction = (data) => async (dispatch) => {
  try {
    const respons = await InsertData(`/api/AgencyStatus`, data);
    dispatch({
      type: InsertAgencyStatus,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: InsertAgencyStatus,
      payload: "Error" + e,
    });
  }
};
export const UpdateAgencyStatusAction = (data) => async (dispatch) => {
  try {
    const respons = await InsUpdateData(`/api/AgencyStatus`, data);
    dispatch({
      type: EditAgencyStatus,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: EditAgencyStatus,
      payload: "Error" + e,
    });
  }
};
export const DeleteAgencyStatusAction = (id) => async (dispatch) => {
  try {
    const respons = await DeleteData(`/api/AgencyStatus?id=${id}`);
    dispatch({
      type: DELETEAgencyStatus,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: DELETEAgencyStatus,
      payload: "Error" + e,
    });
  }
};
export const GetAllAgencyStatusAction = () => async (dispatch) => {
  try {
    const respons = await GetDataToken(`/api/AgencyStatus`);
    dispatch({
      type: GetAgencyStatus,
      payload: respons,
      loading: true,
    });
  } catch (e) {
    dispatch({
      type: GetAgencyStatus,
      payload: "Error" + e,
    });
  }
};